<template>
  <div class="app-container">
    <van-dropdown-menu active-color="#1989fa">
      <van-dropdown-item v-model="params.pickerTime" @change="handleTimeChange" :options="params.pickerTimeOptions" />
      <!-- <van-dropdown-item v-if="params.pickerOrderOptions.length>0" v-model="params.pickerOrder"
        @change="handleOrderChange" :options="params.pickerOrderOptions" /> -->
    </van-dropdown-menu>
    <component :is="currentList" :orders="orders"></component>
  </div>
</template>

<script>
import { DropdownMenu, DropdownItem } from 'vant';
import Available from './components/Available'
import Unavailable from './components/Unavailable'
import { selectWxPaidrecordList } from '@/api/park'
import config from '@/config/index'
import { deepClone, parseTime } from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'Order-List',
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    Available,
    Unavailable
  },
  computed: {
    ...mapGetters(['wx_userInfo', 'zfb_userInfo', 'token', 'chosenTime'])
  },
  created () {
    this.params.pickerTimeOptions = this.chosenTime.pickerTimeOptions
    this.params.pickerTime = this.chosenTime.pickerTimeOptions[0].value
  },
  mounted () {
    this.handleTimeChange(this.params.pickerTime)
  },
  watch: {
    chosenTime: {
      handler (newVal, oldVal) {
        this.params.pickerTimeOptions = newVal.pickerTimeOptions
        this.params.pickerTime = newVal.pickerTimeOptions[0].value
      },
      deep: true
    },

  },
  data () {
    return {
      getInfo_Loading: null,
      currentList: 'Unavailable',
      config,
      listQuery: {
        //过滤参数
        page: 1,
        limit: 10000,
      },
      params: {
        pickerTime: 1,
        pickerOrder: 'positive',
        parkId: null,
        outTradeNo: null,
        pickerTimeOptions: [
        ],
        pickerOrderOptions: [
        ],
        startDate: [
          parseTime(
            new Date(
              new Date(new Date().toLocaleDateString('zh')).getTime()
            )
          ),
          parseTime(new Date(
            new Date(new Date().toLocaleDateString('zh')).getTime() +
            24 * 60 * 60 * 1000 - 1
          ))
        ],
      },
      orders: []
    }
  },
  methods: {
    // 时间选项改变
    handleTimeChange (val) {
      if (val == 1) {
        val = 0
      }
      this.params.startDate[0] = parseTime(new Date(new Date(new Date().toLocaleDateString().replace(/-/g, '/')).getTime() - val * 24 * 60 * 60 * 1000))
      this.componentsValve(null)
    },
    // 排序选项改变
    handleOrderChange (val) {
      this.componentsValve(val)
    },
    componentsValve (parkId) {
      let _this = this
      let params = {
        // billingStatus: 0,
        isParkingOrRoadside: _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType,//订单类型 1 停车场  2 路边
        orderType: _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType,//订单类型 1 停车场  2 路边 3预约 4 关系 5 包月
        openid: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo.userId,
        startTime: _this.params.startDate[0],
        endTime: _this.params.startDate[1],
        startPage: _this.listQuery.page,
        pageSize: _this.listQuery.limit,
      }
      _this.getInfo_Loading = _this.$toast.loading('加载中...')
      selectWxPaidrecordList(params)
        .then(res => {

          let data = res.body.list
          if (parkId == null) {
            _this.params.pickerOrderOptions = []
            data.forEach(element => {
              let obj = {
                value: element.parkId ? element.parkId : 0,
                text: element.parking ? element.parking : "",
                type: element.type ? element.type : 0,
              }
              _this.params.pickerOrderOptions.push(obj)
              _this.params.pickerOrder = _this.params.pickerOrderOptions[0].value
            });
          }

          _this.getInfo_Loading.clear()
          if (data.length > 0) {
            console.log(data)
            _this.orders = deepClone(data)
            _this.currentList = 'Available'
          } else {
            _this.currentList = 'Unavailable'
          }
        })
        .catch(err => {
          _this.getInfo_Loading.clear()
          _this.$notify({
            type: 'danger',
            message: err
          })
        })
    }

  }
}
</script>